import { Team } from 'src/components/team/Team'

export const TeamPage = () => {
  return <Team />
}
